/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */

// save_message y decode_message escriben la misma tabla bajo la misma clave
// 'morse_save_message', así queda una sola copia: quirk del legacy preservado.

const MORSE_DEFINITIONS = `
String codigos [] = {
  "pl", //a
  "lppp", //b
  "lplp", //c
  "lpp", //d
  "p", //e
  "pplp", //f
  "llp", //g
  "pppp", //h
  "pp", //i
  "plll", //j
  "lpl", //k
  "plpp", //l
  "ll", //m
  "lp", //n
  "lll", //o
  "pllp", //p
  "llpl", //q
  "plp", //r
  "ppp", //s
  "l", //t
  "ppl", //u
  "pppl", //v
  "pll", //w
  "lppl", //x
  "lpll", //y
  "llpp" //z
};

long tiempo;

char letra;
String palabra;

boolean presionado;
String mensaje;
`;

export const morse_save_message = (block, generator) => {
  generator.definitions_.morse_save_message = MORSE_DEFINITIONS;
  return `
if (presionado == false) {
  tiempo = millis();
  presionado = true;
} else {
  if ( millis() < tiempo + 350) {
    letra = 'p';
  } else {
    letra = 'l';
  }
}
`;
};

export const morse_decode_message = (block, generator) => {
  generator.definitions_.morse_save_message = MORSE_DEFINITIONS;
  return `
if (presionado == true) {
  palabra += letra;
  presionado = false;
  tiempo = millis();
} else {
  if (millis() > tiempo + 2000) {
    for (int i = 0; i < 26; i++) {
      if (palabra == codigos[i]) {
        Serial.print(palabra);
        Serial.print(" La letra es: ");
        char le = 65 + i;
        mensaje += le;
        Serial.print(le);
        Serial.print(" ");
        Serial.println(i);
        palabra = "";
      }
    }
  }
}
`;
};

export const morse_get_message = (block, generator) => {
  generator.definitions_.morse_get_message = `
String mostrarMensaje(){
  String mimensaje = mensaje;
  mensaje = "";
  return mimensaje;
}
`;
  return ['mostrarMensaje()', generator.ORDER_ATOMIC];
};
